import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs, DataSourceChangedEventArgs } from '@syncfusion/ej2-angular-grids';
import { HttpBackend, HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { LocalStorageService } from '../localStorage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class VisitorregService extends Subject<DataStateChangeEventArgs> {
  private httpClient: HttpClient;
  constructor(private handler: HttpBackend, private http: HttpClient, private storageService: LocalStorageService) {
    super();
    this.httpClient = new HttpClient(handler);
   }

   handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
  //  window.alert(errorMessage);
  console.log("Error:",errorMessage);
    return throwError(errorMessage);
  }

  // Create visitors
  createvisitor(user: Object): Observable<Object> {
    console.log("In createvisitor method, visitor: ", user);
    return this.http.post(`${environment.apiUrl}/visitors`, user).pipe(catchError(this.handleError));
  }

 // Getvisitor by Id Get
 getvisitor(id: number): Observable<Object> {
  return this.http.get(`${environment.apiUrl}/visitors/${id}`).pipe(catchError(this.handleError));
}

//Delete visitor by Id Delete
deletevisitor(id: number): Observable<Object> {
  return this.http.delete(`${environment.apiUrl}/visitors/${id}`).pipe(catchError(this.handleError));
}

//Update visitors by Id Put
updatevisitor(user: Object,id: number): Observable<Object> {
  console.log("In createUser method, user: ", user);
  return this.http.put(`${environment.apiUrl}/visitors/${id}`, user).pipe(catchError(this.handleError));
}

  //Get All Contact by Id Get
  getAllvisitor(): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/visitors`).pipe(catchError(this.handleError));
  }

}
